"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fab = void 0;
var _react = _interopRequireDefault(require("react"));
var _Fab = _interopRequireDefault(require("@material-ui/core/Fab"));
var _core = require("@material-ui/core");
var _pittaModules = require("@thingsw/pitta-modules");
var _excluded = ["variant"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: function root(props) {
      return _objectSpread(_objectSpread(_objectSpread({}, props.variant === "rounded" ? {
        borderRadius: 4
      } : {}), props.variant === "rounded" && props.size === "small" ? {
        width: 36,
        height: 36
      } : {}), {}, {
        backgroundColor: _pittaModules.LightColors.primary["0"],
        color: _pittaModules.LightColors.primary["1"],
        boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.14), 0px 1px 1px rgba(0, 0, 0, 0.12), 0px 0px 3px rgba(0, 0, 0, 0.2)",
        "&:hover": {
          backgroundColor: _pittaModules.LightColors.primary["0"],
          color: _pittaModules.LightColors.primary["7"],
          fill: _pittaModules.LightColors.primary["7"]
        },
        "&:active": {
          backgroundColor: _pittaModules.LightColors.primary["10"],
          color: _pittaModules.LightColors.primary["7"],
          fill: _pittaModules.LightColors.primary["7"],
          boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.14), 0px 1px 1px rgba(0, 0, 0, 0.12), 0px 0px 3px rgba(0, 0, 0, 0.2)"
        },
        "&.Mui-disabled": {
          backgroundColor: "".concat(_pittaModules.LightColors.primary[0], "C0")
        }
      });
    }
  };
});
var Fab = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles(_objectSpread({
    variant: variant
  }, props));
  return /*#__PURE__*/_react.default.createElement(_Fab.default, _extends({
    ref: ref,
    classes: classes,
    disableFocusRipple: true,
    disableRipple: true
  }, props));
});
exports.Fab = Fab;